var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-login"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('ai.k_023001')))]),_c('vh-button',{attrs:{"type":"text"},on:{"click":_vm.handleWxworkLogin}},[_c('img',{staticClass:"wxwork-img",attrs:{"src":require("../images/wxwork.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }